export default {
  SET_BENEFIT(state, payload) {
    state.benefit = payload
  },
  SET_BENEFIT_DISTRIBUTION(state, payload) {
    state.benefitDistribution = payload
  },
  SET_BENEFIT_MOVEMENT_HISTORY(state, payload) {
    state.generatedBenefitCode = payload
  },
  SET_GENERATED_BENEFIT_CODE(state, payload) {
    state.benefitMovementHistory = payload
  },
  SET_METRICS(state, payload) {
    state.metrics = payload
  },
}
